// Components the Campaigns, Templates, Schedule and Sending pages share.

import type { CampaignStatus, SendStatus, TemplateCheck } from '@/api/growthCampaignTypes'
import { Badge, CheckIcon, XIcon } from '@/components/ui'
import { cn } from '@/lib/format'
import { CAMPAIGN_STATUS_LABELS, CAMPAIGN_STATUS_TONE, SEND_STATUS_LABELS, SEND_STATUS_TONE } from '@/lib/growthCampaigns'

export function CampaignStatusBadge({ status }: { status: CampaignStatus }) {
  return <Badge tone={CAMPAIGN_STATUS_TONE[status]}>{CAMPAIGN_STATUS_LABELS[status]}</Badge>
}

export function SendStatusBadge({ status }: { status: SendStatus }) {
  return <Badge tone={SEND_STATUS_TONE[status]}>{SEND_STATUS_LABELS[status]}</Badge>
}

/** The compliance check: what passed, what didn't, and what's only advice. */
export function CheckList({ checks, label = 'Compliance check' }: { checks: TemplateCheck[]; label?: string }) {
  return (
    <ul aria-label={label} className="grid gap-2.5">
      {checks.map((c) => {
        const Icon = c.ok ? CheckIcon : XIcon
        const tone = c.ok ? 'text-good' : c.required ? 'text-bad' : 'text-warn'
        return (
          <li key={c.id} className="flex items-start gap-2">
            <Icon size={15} aria-hidden className={cn('mt-0.5 shrink-0', tone)} />
            <span className="min-w-0 text-[13px]">
              <span className="font-semibold text-ink">
                {c.label}
                <span className="sr-only">{c.ok ? ': passed' : c.required ? ': failed' : ': advice'}</span>
              </span>
              <span className="block break-words text-muted">{c.message}</span>
            </span>
          </li>
        )
      })}
    </ul>
  )
}
